import { ApiResponse, PaginatedResponse } from '../../types/common';
import {
  ClaimApprovalDto,
  ExpenseApprovalDecision,
  PendingApprovalListItem,
  SubmitApprovalDecisionRequest,
} from '../../types/expenses';
import { axiosInstance } from './axios';

export const expenseApprovalService = {
  getPendingApprovals: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<PendingApprovalListItem>> => {
    const response = await axiosInstance.get<{ succeeded: boolean; messages: string[]; data: PaginatedResponse<PendingApprovalListItem> }>(
      'v1/Expenses/approvals/pending',
      { params: { page: params?.page ?? 1, limit: params?.limit ?? 20 } }
    );
    if (!response.data.succeeded) {
      throw new Error(response.data.messages?.[0] || 'Failed to fetch pending approvals');
    }
    return response.data.data;
  },

  getTimeline: async (claimId: number): Promise<ClaimApprovalDto[]> => {
    const response = await axiosInstance.get<ApiResponse<ClaimApprovalDto[]>>(
      `v1/Expenses/claims/${claimId}/timeline`
    );
    if (!response.data.succeeded) {
      throw new Error(response.data.messages?.[0] || 'Failed to fetch approval timeline');
    }
    return response.data.data;
  },

  submitDecision: async (data: SubmitApprovalDecisionRequest): Promise<number> => {
    const response = await axiosInstance.post<ApiResponse<number>>(
      `v1/Expenses/approvals/claims/${data.claimId}/decision`,
      data
    );
    if (!response.data.succeeded) {
      throw new Error(response.data.messages?.[0] || 'Failed to submit decision');
    }
    return response.data.data;
  },
};
